module.exports = __webpack_public_path__ + "static/media/0003.5081032.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0003.mp3
// module id = 7FH+
// module chunks = 0